import { Checkbox, type CheckboxProps } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

import styles from './Field.module.scss';

interface IProps extends CheckboxProps {
  fieldName: string;
}

export const CheckboxField = ({ fieldName, children, ...restProps }: IProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      render={({ field: { value, ...restFieldProps } }) => (
        <div className={styles['field-wrapper']}>
          <Checkbox
            {...restFieldProps}
            {...restProps}
            checked={value as boolean}
          >
            {children}
          </Checkbox>
        </div>
      )}
    />
  );
};
